import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from '../../../components/modal/Modal';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';

type Props = {
  lawyerName: string;
  closeModal: () => void;
  isOpen: boolean;
  handleClick: () => void;
};

export const VerifyLawyerModalFirstStep: FC<Props> = ({
  closeModal,
  isOpen,
  lawyerName,
  handleClick,
}) => (
  <Modal isOpen={isOpen} onRequestClose={closeModal}>
    <div className="small-modal__header">
      <button type="button" onClick={closeModal}>
        <MaterialIcon name="close" className="small-modal__close" />
      </button>
    </div>
    <div className="restricted-modal__content">
      <img src="/img/icons/verify.png" alt="verify-icon" />
      <div className="restricted-modal__title">
        <FormattedMessage id="entity/expertises/VerifyLawyerModalFirstStep.tsx/1" />
      </div>
      <div className="restricted-modal__verify__content">
        <div className="restricted-modal__verify__line">
          <img
            className="restricted-modal__verify__line__pic"
            src="/img/icons/tel.png"
            alt="phone-icon"
          />
          <div className="restricted-modal__verify__line__text">
            <span className="restricted-modal__verify__line__text__title">
              <FormattedMessage id="entity/expertises/VerifyLawyerModalFirstStep.tsx/2" />
            </span>
            <p>
              <FormattedMessage id="entity/expertises/VerifyLawyerModalFirstStep.tsx/3" />
            </p>
          </div>
        </div>
        <div className="restricted-modal__verify__line">
          <img
            className="restricted-modal__verify__line__pic"
            src="/img/icons/email-gray.png"
            alt="email-icon"
          />
          <div className="restricted-modal__verify__line__text">
            <span className="restricted-modal__verify__line__text__title">
              <FormattedMessage id="entity/expertises/VerifyLawyerModalFirstStep.tsx/4" />
            </span>
            <p>
              <FormattedMessage id="entity/expertises/VerifyLawyerModalFirstStep.tsx/5" />
            </p>
          </div>
        </div>
      </div>
      <button
        className="button large brand restricted-modal__start-button"
        type="button"
        onClick={handleClick}
      >
        <MaterialIcon
          name="arrow_forward"
          className="restricted-modal__start-button__arrow"
        />
        <FormattedMessage id="entity/expertises/VerifyLawyerModalFirstStep.tsx/6" />{' '}
        {lawyerName}
      </button>
    </div>
  </Modal>
);
